module.exports = __webpack_public_path__ + "img/Neutro_Corpo_2.13dea83c.png";